import React from "react";
import { Button } from "@networkraildigitalfactory/components";

const ActionButtons = (props) => {
  const { status, isLineManager, goToEditView, goToBeginOneToOneView } = props;
  switch (status) {
    case "submitted":
      return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            color="blue"
            text={isLineManager ? "Begin 1-2-1" : "Edit"}
            name={isLineManager ? "begin-1-2-1" : "edit"}
            onClick={isLineManager ? goToBeginOneToOneView : goToEditView}
            style={{ marginLeft: 0 }}
          />
        </div>
      );
    case "begin-1-2-1":
      return (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            color="blue"
            text="Begin 1-2-1"
            name="begin-1-2-1"
            onClick={goToBeginOneToOneView}
            style={{ marginLeft: 0 }}
          />
        </div>
      );
    default:
      return <></>;
  }
};

export default ActionButtons;
